<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" i18n="@@oltreauth.title.login">Login</h4>
</div>
<div class="modal-body">
  <form id="loginform" [formGroup]="form" (ngSubmit)="submit.next()">
    @if (step() === 1) {
      <div class="col-12">
        <label for="name" class="form-label" i18n="@@oltreauth.label.name">Name</label>
        <input
          type="text"
          formControlName="name"
          class="form-control"
          [class.is-invalid]="form.controls.name.invalid && (form.controls.name.dirty || form.controls.name.touched)"
          required
        />
        @if (form.controls.name.hasError('required') && (form.controls.name.dirty || form.controls.name.touched)) {
          <div class="invalid-feedback" i18n="@@oltreauth.feedback.mandatoryname">Name is mandatory</div>
        } @else {
          <div class="invalid-feedback d-block invisible">placeholder</div>
        }
      </div>
      <div class="col-12">
        <label for="password" class="form-label">Password</label>
        <input
          type="password"
          formControlName="password"
          class="form-control"
          [class.is-invalid]="form.controls.password.invalid && (form.controls.password.dirty || form.controls.password.touched)"
          required
        />
        @if (form.controls.password.hasError('required') && (form.controls.password.dirty || form.controls.password.touched)) {
          <div class="invalid-feedback" i18n="@@oltreauth.feedback.mandatorypassword">Password is mandatory</div>
        } @else {
          <div class="invalid-feedback d-block invisible">placeholder</div>
        }
      </div>
    } @else {
      <div class="col-12">
        <label for="otp" class="form-label">OTP Code</label>
        <input
          #otpInput
          type="text"
          formControlName="otp"
          class="form-control"
          [class.is-invalid]="form.controls.otp.invalid && (form.controls.otp.dirty || form.controls.otp.touched)"
          required
        />
        @if (form.controls.otp.hasError('required') && (form.controls.otp.dirty || form.controls.otp.touched)) {
          <div class="invalid-feedback" i18n="@@oltreauth.feedback.mandatoryotp">OTP Code is mandatory</div>
        } @else {
          <div class="invalid-feedback d-block invisible">placeholder</div>
        }
      </div>
    }
  </form>
  @if (error()) {
    <div class="alert alert-danger mt-3">
      @if (step() === 1) {
        <span i18n="@@oltreauth.feedback.loginunsuccessful">Login unsuccessful</span>
      } @else {
        <span i18n="@@oltreauth.feedback.invalidotp">Invalid OTP</span>
      }
    </div>
  }
  @if (messages(); as msgs) {
    <ul class="list-group list-group-flush">
      @for (message of msgs; track message) {
        @switch (message.type) {
          @case (MessageType.Info) {
            <li class="list-group-item list-group-item-primary">{{ message.text }}</li>
          }
          @case (MessageType.Warning) {
            <li class="list-group-item list-group-item-warning">{{ message.text }}</li>
          }
          @case (MessageType.Error) {
            <li class="list-group-item list-group-item-danger">{{ message.text }}</li>
          }
          @case (MessageType.Timeout) {
            @if (isMessageTimeout(message)) {
              <li class="list-group-item list-group-item-primary">
                {{ message.text }}
                <app-time-delta [target]="message.date"></app-time-delta>
              </li>
            }
          }
          @case (MessageType.Link) {
            @if (isMessageLink(message)) {
              <li class="list-group-item list-group-item-primary">
                <a class="btn-link" [routerLink]="message.url">{{ message.text }}</a>
              </li>
            }
          }
        }
      }
    </ul>
  }
</div>
<div class="modal-footer">
  @for(message of actions; track message) {
    <a class="btn-link" [routerLink]="message.url">{{ message.text }}</a>
  }
  <button type="button" class="btn" (click)="close()" i18n="@@oltreauth.button.cancel">Cancel</button>
  <button
    form="loginform"
    type="submit"
    class="btn btn-outline-dark"
    [disabled]="error() || submitting() || (step() === 1 ? form.controls.name.invalid || form.controls.password.invalid : form.controls.otp.invalid)"
  >
    @if (step() === 1) {
      <span [class.throb]="submitting()" i18n="@@oltreauth.button.next">Next</span>
    } @else {
      <span [class.throb]="submitting()" i18n="@@oltreauth.button.login">Login</span>
    }
  </button>
</div>
